// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu-rtl_list__2SdC7","title":"Menu-rtl_title__1TMBX","menuItemActive":"Menu-rtl_menuItemActive__1GVVt","activeCurve":"Menu-rtl_activeCurve__3sE6Q"};